<template>
    <div class>
        <section class="checkout_wizard pb-0">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <!-- Split Shipment Wizard (8 Steps) -->
                        <template v-if="isSplitShipment">
                            <div class="wizard d-flex justify-content-center align-items-center">
                                <router-link :to="{ name: 'cartV3' }">
                                    <div class="field d-flex justify-content-center align-items-center">
                                        <div class="circle done mr_10">
                                            <img src="/maincss/images/wizard_checked.svg" alt />
                                        </div>
                                        <h5 class="mb-0">Shopping Cart</h5>
                                    </div>
                                </router-link>
                                <div class="devider"></div>
                                <div class="field d-flex justify-content-center align-items-center" :class="{ 'done': split_shipment_step && ['split_items', 'charges', 'billing', 'payment', 'review'].includes(split_shipment_step) }">
                                    <div class="circle mr_10" :class="{ 'done': split_shipment_step && ['split_items', 'charges', 'billing', 'payment', 'review'].includes(split_shipment_step) }">
                                        <img v-if="split_shipment_step && ['split_items', 'charges', 'billing', 'payment', 'review'].includes(split_shipment_step)" src="/maincss/images/wizard_checked.svg" alt />
                                        <span v-else>2</span>
                                    </div>
                                    <h5 class="mb-0">Shipping Addresses</h5>
                                </div>
                                <div class="devider"></div>
                                <div class="field d-flex justify-content-center align-items-center" :class="{ 'done': split_shipment_step && ['charges', 'billing', 'payment', 'review'].includes(split_shipment_step) }">
                                    <div class="circle mr_10" :class="{ 'done': split_shipment_step && ['charges', 'billing', 'payment', 'review'].includes(split_shipment_step) }">
                                        <img v-if="split_shipment_step && ['charges', 'billing', 'payment', 'review'].includes(split_shipment_step)" src="/maincss/images/wizard_checked.svg" alt />
                                        <span v-else>3</span>
                                    </div>
                                    <h5 class="mb-0">Split Items</h5>
                                </div>
                                <div class="devider d-none"></div>
                                <div class="field d-flex justify-content-center align-items-center d-none" :class="{ 'done': split_shipment_step && ['charges', 'billing', 'payment', 'review'].includes(split_shipment_step) }">
                                    <div class="circle mr_10 d-none" :class="{ 'done': split_shipment_step && ['charges', 'billing', 'payment', 'review'].includes(split_shipment_step) }">
                                        <img v-if="split_shipment_step && ['charges', 'billing', 'payment', 'review'].includes(split_shipment_step)" src="/maincss/images/wizard_checked.svg" alt />
                                        <span v-else>4</span>
                                    </div>
                                    <h5 class="mb-0 d-none">Packaging</h5>
                                </div>
                                <div class="devider"></div>
                                <div class="field d-flex justify-content-center align-items-center" :class="{ 'done': split_shipment_step && ['billing', 'payment', 'review'].includes(split_shipment_step) }">
                                    <div class="circle mr_10" :class="{ 'done': split_shipment_step && ['billing', 'payment', 'review'].includes(split_shipment_step) }">
                                        <img v-if="split_shipment_step && ['billing', 'payment', 'review'].includes(split_shipment_step)" src="/maincss/images/wizard_checked.svg" alt />
                                        <span v-else>4</span>
                                    </div>
                                    <h5 class="mb-0">Charges Summary</h5>
                                </div>
                                <div class="devider"></div>
                                <div class="field d-flex justify-content-center align-items-center" :class="{ 'done': split_shipment_step && ['payment', 'review'].includes(split_shipment_step) }">
                                    <div class="circle mr_10" :class="{ 'done': split_shipment_step && ['payment', 'review'].includes(split_shipment_step) }">
                                        <img v-if="split_shipment_step && ['payment', 'review'].includes(split_shipment_step)" src="/maincss/images/wizard_checked.svg" alt />
                                        <span v-else>5</span>
                                    </div>
                                    <h5 class="mb-0">Billing Address</h5>
                                </div>
                                <div class="devider"></div>
                                <div class="field d-flex justify-content-center align-items-center" :class="{ 'done': split_shipment_step === 'review' }">
                                    <div class="circle mr_10" :class="{ 'done': split_shipment_step === 'review' }">
                                        <img v-if="split_shipment_step === 'review'" src="/maincss/images/wizard_checked.svg" alt />
                                        <span v-else>6</span>
                                    </div>
                                    <h5 class="mb-0">Payment & Shipment</h5>
                                </div>
                                <div class="devider"></div>
                                <div class="field d-flex justify-content-center align-items-center" :class="{ 'done': split_shipment_step === 'review' }">
                                    <div class="circle mr_10" :class="{ 'done': split_shipment_step === 'review' }">
                                        <img v-if="split_shipment_step === 'review'" src="/maincss/images/wizard_checked.svg" alt />
                                        <span v-else>7</span>
                                    </div>
                                    <h5 class="mb-0">Review & Pay</h5>
                                </div>
                            </div>
                        </template>
                        
                        <!-- Standard Checkout Wizard (4 Steps) -->
                        <template v-else>
                            <div class="wizard d-flex justify-content-center align-items-center">
                                <router-link :to="{ name: 'cartV3' }">
                                    <div class="field d-flex justify-content-center align-items-center">
                                        <div class="circle done mr_10">
                                            <img src="/maincss/images/wizard_checked.svg" alt />
                                        </div>
                                        <h5 class="mb-0">Shopping Cart</h5>
                                    </div>
                                </router-link>
                                <div class="devider"></div>
                                <div
                                    v-if="is_reviewpay || is_payment"
                                    @click="manageUpperThreeLinks('shipping_billing')"
                                    class="field d-flex justify-content-center align-items-center"
                                >
                                    <div class="circle done mr_10">
                                        <img src="/maincss/images/wizard_checked.svg" alt="" />
                                    </div>
                                    <h5 class="mb-0">Shipping & Billing Address</h5>
                                </div>
                                <div
                                    v-else
                                    class="field d-flex justify-content-center align-items-center"
                                >
                                    <div class="circle mr_10">2</div>
                                    <h5 class="mb-0">Shipping & Billing Address</h5>
                                </div>
                                <div class="devider"></div>
                                <div
                                    v-if="is_payment || is_reviewpay"
                                    @click="manageUpperThreeLinks('payment_shipment')"
                                    class="field d-flex justify-content-center align-items-center"
                                >
                                    <div class="circle done mr_10" v-if="is_reviewpay">
                                        <img src="/maincss/images/wizard_checked.svg" alt="" />
                                    </div>
                                    <div v-else class="circle mr_10">3</div>
                                    <h5 class="mb-0">Payment & Shipment</h5>
                                </div>
                                <div
                                    v-else
                                    class="field in_active d-flex justify-content-center align-items-center"
                                >
                                    <div class="circle mr_10">3</div>
                                    <h5 class="mb-0">Payment & Shipment</h5>
                                </div>
                                <div class="devider"></div>
                                <div
                                    @click="manageUpperThreeLinks('review_pay')"
                                    v-if="is_reviewpay"
                                    class="field d-flex justify-content-center align-items-center"
                                >
                                    <div class="circle mr_10">4</div>
                                    <h5 class="mb-0">Review & Pay</h5>
                                </div>
                                <div
                                    v-else
                                    class="field in_active d-flex justify-content-center align-items-center"
                                >
                                    <div class="circle mr_10">4</div>
                                    <h5 class="mb-0">Review & Pay</h5>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </section>

        <section class="breadcrumb-section">
            <div class="container">
                <nav aria-label="breadcrumb" v-if="false">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'home' }"
                                >Home</router-link
                            >
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'cart' }"
                                >Cart</router-link
                            >
                        </li>
                    </ol>
                </nav>
            </div>
        </section>

        <section class="checkout_error_msg p-0">
            <div class="container">
                <div class="row">
                    <div v-show="email_verified" class="col-md-12">
                        <div
                            class="alert alert-danger d-flex justify-content-between align-items no-cart-message"
                            role="alert"
                        >
                            <div class="alert_message">
                                <span>
                                    Please verify your account to complete
                                    checkout process!</span
                                >
                            </div>
                            <div class="alert_btn">
                                <a
                                    href="#"
                                    class="btn bnt-primary mr_20 refresh"
                                    @click="forceRerender"
                                    >Refresh</a
                                >
                                <a
                                    href="#"
                                    class="btn bnt-primary"
                                    @click="resendLink"
                                    >Resend Link</a
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="shipping_payment_detail shipping_payment pt-0 pb_150">
            <div class="container">
                <div class="row" v-if="is_reviewpay"></div>
                <div class="row">
                    <!-- Split Shipment Address Manager -->
                    <SplitShipmentAddressManager
                        v-if="isSplitShipment && split_shipment_step === 'addresses'"
                        @go-back="goBackToCart"
                        @proceed-next="proceedToSplitItems"
                        @proceed-to-billing="proceedToBilling"
                        @exit-split-shipment="handleExitSplitShipment"
                    />
                    
                    <!-- Split Items By Address (when name_and_number_json has data) -->
                    <SplitItemsByAddress
                        ref="splitItemsByAddress"
                        v-if="isSplitShipment && split_shipment_step === 'split_items' && hasNameNumberData"
                        @go-back-to-addresses="goBackToAddresses"
                        @all-addresses-complete="proceedToPackaging"
                    />
                    
                    <!-- Bulk Personalization Split (when name_and_number_json is empty/blank) -->
                    <BulkPersonalizationSplit
                        ref="bulkPersonalizationSplit"
                        v-if="isSplitShipment && split_shipment_step === 'split_items' && !hasNameNumberData"
                        @go-back-to-addresses="goBackToAddresses"
                        @all-addresses-complete="proceedToPackaging"
                    />
                    
                    <!-- Packaging Options (step skipped: default standard, UI hidden) -->
                    <PackagingOptions
                        v-if="false"
                        class="d-none"
                    />
                    
                    <!-- Summary Of Additional Charges -->
                    <SummaryOfAdditionalCharges
                        v-if="isSplitShipment && split_shipment_step === 'charges'"
                    />
                    
                    <!-- Billing Address -->
                    <BillingAddress
                        v-if="isSplitShipment && split_shipment_step === 'billing' && order_data"
                        :order_data="order_data"
                    />
                    
                    <!-- Payment & Shipment for Split Shipment -->
                    <PaymentShipment
                        v-if="isSplitShipment && split_shipment_step === 'payment' && order_data"
                        :key="'payment-split-' + split_shipment_step"
                        :order_data="order_data"
                        :netsuite_customer_data="netsuite_customer_data"
                        :termPaymentInfo="term_payment_info"
                        :enableTermPayment="true"
                        ref="PayShipmentRefSplit"
                    />
                    
                    <!-- Review & Pay for Split Shipment -->
                    <ReviewPay
                        v-if="isSplitShipment && split_shipment_step === 'review'"
                        ref="reviewPayCompSplit"
                        :order_data="order_data"
                        :termPaymentInfo="term_payment_info"
                    />
                    
                    <!-- Standard Checkout Flow -->
                    <template v-if="!isSplitShipment || (split_shipment_step !== 'addresses' && split_shipment_step !== 'split_items' && split_shipment_step !== 'packaging' && split_shipment_step !== 'charges' && split_shipment_step !== 'billing' && split_shipment_step !== 'payment' && split_shipment_step !== 'review')">
                        <ReviewPay
                            ref="reviewPayComp"
                            v-show="is_reviewpay"
                            :order_data="order_data"
                            :termPaymentInfo="term_payment_info"
                        />
                        <ShippingPayment v-show="!is_reviewpay && !is_payment && !isSplitShipment" />
                        <PaymentShipment
                            v-show="!is_reviewpay && is_payment && !isSplitShipment"
                            :order_data="order_data"
                            :netsuite_customer_data="netsuite_customer_data"
                            :termPaymentInfo="term_payment_info"
                            :enableTermPayment="true"
                            ref="PayShipmentRef"
                        />
                    </template>
                    
                    <CartSummary
                        :is_reviewpay="is_reviewpay"
                        :order_data="order_data"
                        ref="cartSummaryRef"
                    />
                    <!-- v-show="cartNotEmpty" -->
                </div>
            </div>
        </section>

        <!-- <div v-if="is_reviewpay" class="container">
            <div class="row">
                <div class="col-md-3"></div>
                <div class="col-md-6">
                    <div class="procced_to_pay_btn_rv">
                        <button
                            v-if="isAdminLoggedIn"
                            v-on:click="placeOrder"
                            class="btn btn_orange bg_primary_orange text_white d-block py_22"
                            style="width: 571px; margin: 0 auto"
                        >
                            Proceed To Checkout
                        </button>
                         <button
                            v-else
                            v-on:click="placeOrder"
                            class="btn btn_orange bg_primary_orange text_white d-block py_22"
                            style="width: 571px; margin: 0 auto"
                        >
                            Proceed To Pay 
                        </button>
                    </div>
                    <center class="procced_to_pay_terms by_placing_spaceing">
                        <p class="font_size_16 text_light_grey">
                            By placing your order at
                            <router-link class="opacity_60" :to="{ path: '/' }"
                                >imprintcity.com</router-link
                            >
                            you're agreeing to our
                            <br />
                            <router-link
                                class="opacity_60"
                                :to="{ name: 'PrivacyPolicy' }"
                                >Privacy Policy</router-link
                            >
                            &
                            <router-link
                                class="opacity_60"
                                :to="{ name: 'TermsConditions' }"
                                >Terms & Conditions</router-link
                            >. We may occasionally email you product
                            information.
                        </p>
                    </center>
                </div>
                <div class="col-md-3"></div>
            </div>
        </div> -->
        <div class="preloader" v-show="isLoader">
            <div class="preloader-body">
                <svg width="40" height="40" viewBox="0 0 40 40">
                    <polygon class="rect" points="0 0 0 40 40 40 40 0" />
                </svg>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import CartSummary from "@/components/cart/V3/CartSummary";
import ShippingPayment from "@/components/ShippingPayment";
import PaymentShipment from "@/components/PaymentShipmentV2";
import ReviewPay from "@/components/ReviewPay";
import SplitShipmentAddressManager from "@/components/cart/V3/SplitShipmentAddressManager.vue";
import SplitItemsByAddress from "@/components/cart/V3/SplitItemsByAddress.vue";
import BulkPersonalizationSplit from "@/components/cart/V3/BulkPersonalizationSplit.vue";
import PackagingOptions from "@/components/cart/V3/PackagingOptions.vue";
import SummaryOfAdditionalCharges from "@/components/cart/V3/SummaryOfAdditionalCharges.vue";
import BillingAddress from "@/components/cart/V3/BillingAddress.vue";
import ApiService from "@/common/api.service";

export default {
    /* eslint-disable */
    name: "Checkout",
    /* eslint-enable */
           components: { CartSummary, ShippingPayment, ReviewPay, PaymentShipment, SplitShipmentAddressManager, SplitItemsByAddress, BulkPersonalizationSplit, PackagingOptions, SummaryOfAdditionalCharges, BillingAddress },
    data() {
        return {
            email_verified: false,
            getting_email: null,
            total_weight_in_lbs: 0.0,
            cartLoading: false,
            isLoader: false,
            placingOrder: false,
            is_reviewpay: false,
            is_payment: false,
            split_shipment_step: null, // null, 'addresses', 'split_items', 'packaging', etc.
            all_states: [],
            address_data: {
                address1: "",
                address2: "",
                state: "",
                city: "",
                pincode: ""
            },
            all_address: [],
            shippingCarriers: [],
            order_data: {
                fullname: "",
                firstName: "",
                lastName: "",
                email: "",
                phone: "",
                billingaddressid: "",
                shippingaddressid: "",
                sameaddress: true,
                billing_first_name: "",
                billing_last_name: "",
                address_label: "",
                addresszip: "",
                addressstate: "",
                billingcountry: "United States Of America",
                shipping_first_name: "",
                shipping_last_name: "",
                shippingaddress_label: "",
                shippingphone: "",
                shippingaddresszip: "",
                shippingaddressstate: "",
                shippingcountry: "United States Of America",
                shippingproviderid: "",
                shipping_provider_name: "",
                shippingmethod: "",
                estimated_delivery_date: null,
                estimated_delivery_days: null,
                giftcardnumber: "",
                giftcardpin: "",
                couponcode: "",
                specialcomment: "",
                /** Split checkout billing-step note only (payment uses `specialcomment`). Copied into `comment` when placing split order. */
                billing_order_comment: "",
                comment: "",
                is_paypal: "",
                is_cod: 0,
                is_pay_later: 0,
                is_credit_card: "",
                total_price: "",
                grand_total_price: "",
                total_quantity: "",
                items: "",
                shippingproviderimage: "",
                grand_total: "",
                order_price: 0,
                shipping_price: "",
                credit_limit: "",
                sales_tax: 0,
                is_remaining_pay_card: false,
                remaining_pay_card_details: {
                    id: "",
                    cardtype: "",
                    cardimage: "",
                    cardnumber: "",
                    cardholdername: "",
                    cardexpiremonth: ("0" + (new Date().getMonth() + 1)).slice(
                        -2
                    ),
                    cardexpireyear: new Date()
                        .getFullYear()
                        .toString()
                        .substr(-2),
                    customerPaymentProfileId: "",
                    customerProfileId: "",
                    cardsecuritycode: ""
                },
                total_non_standard_fees: 0,
                total_color_fees: 0,
                total_setup_fees: 0,
                admin_user_id: 0
            },
            selected_shiping_method: null,
            creditLimit: null,
            pay_type: null,
            netsuite_customer_data: null,
            total_orders: 0,
            unsynced_orders_amount: 0,
            term_payment_info: {
                creditlimit: 0,
                overdue_balance: 0,
                unbilled_orders: 0,
                unpaid_invoices: 0,
                avalaible_on_account: 0,
                unapplied_credits: 0
            }
        };
    },
    mounted() {
        /* eslint-disable */
        if (!this.isAuthenticatedClient) {
            //$("#login").modal("show");
            this.$router.push({ name: "home" });
            return;
        }
        var _this = this;
        document.body.classList.add("bg_primary_light_white");
        $(document).on("hide.bs.modal", "#address", function () {
            _this.$validator.reset();
            _this.address_data = {
                address1: "",
                address2: "",
                state: "",
                city: "",
                pincode: ""
            };
            //Do stuff here
        });
        /* eslint-enable */
        _this.cartNotEmpty = localStorage.getItem("cartNotEmpty");
        this.getUser();
        this.getOrdersCount();
        
        // Set split shipment step only when not already set (preserve step when returning to checkout / Back from Review)
        if (this.$store.state.splitShipment && this.$store.state.splitShipment.isSplitShipment) {
            if (!this.split_shipment_step) {
                this.split_shipment_step = 'addresses';
            }
        } else {
            this.split_shipment_step = null;
        }
    },
    beforeRouteLeave(to, from, next) {
        // When user leaves checkout (e.g. clicks Cart, navigates elsewhere), reset split shipment so next entry is fresh
        if (this.$store.state.splitShipment && this.$store.state.splitShipment.isSplitShipment) {
            this.$store.commit('splitShipment/resetSplitShipment');
        }
        this.split_shipment_step = null;
        next();
    },
    computed: {
        ...mapGetters([
            "isAuthenticatedClient",
            "currentUserClient",
            "isAdminLoggedIn"
        ]),
        tag() {
            return this.$route.params.tag;
        },
        isSplitShipment() {
            return this.$store.state.splitShipment && this.$store.state.splitShipment.isSplitShipment;
        },
        splitAddresses() {
            return this.$store.getters['splitShipment/splitAddresses'] || [];
        },
        hasNameNumberData() {
            // Check if any cart item has non-empty name_and_number_json
            const cartSummaryRef = this.$refs.cartSummaryRef;
            if (!cartSummaryRef || !cartSummaryRef.cart_items) {
                return false;
            }
            
            const cartItems = cartSummaryRef.cart_items;
            for (let i = 0; i < cartItems.length; i++) {
                const item = cartItems[i];
                const nameNumberJson = item.name_and_number_json;
                
                if (nameNumberJson) {
                    try {
                        let nameNumberData = null;
                        if (typeof nameNumberJson === 'string') {
                            nameNumberData = JSON.parse(nameNumberJson);
                        } else if (typeof nameNumberJson === 'object') {
                            nameNumberData = nameNumberJson;
                        }
                        
                        if (nameNumberData && typeof nameNumberData === 'object') {
                            // Check if any location (front, back, left, right) has non-empty array
                            const locations = ['front', 'back', 'left', 'right'];
                            for (let loc of locations) {
                                if (nameNumberData[loc] && Array.isArray(nameNumberData[loc]) && nameNumberData[loc].length > 0) {
                                    // Found at least one location with data
                                    return true;
                                }
                            }
                        }
                    } catch (e) {
                        // Ignore parsing errors, continue checking other items
                        console.warn("[Checkout] Error parsing name_and_number_json:", e);
                    }
                }
            }
            
            return false;
        }
    },
    watch: {
        isSplitShipment(newVal) {
            // When split shipment is disabled, reset step and ensure normal flow
            if (!newVal) {
                this.split_shipment_step = null;
            } else if (newVal && !this.split_shipment_step) {
                // When split shipment is enabled, set to addresses step
                this.split_shipment_step = 'addresses';
            }
        }
    },
    methods: {
        resendLink() {
            var _this = this;
            new Promise(() => {
                setTimeout(() => {
                    ApiService.get(
                        "/send-email-verification-link/" + this.getting_email
                    )
                        .then(({ data }) => {
                            _this.$toast.success(data.message, {
                                position: "top-right"
                            });
                        })
                        .catch(({ response }) => {
                            console.log(response.status.errors);
                        });
                }, 500);
            });
        },
        forceRerender() {
            this.$router.go(this.$router.currentRoute);
        },
        proceedToBilling() {
    this.split_shipment_step = 'billing';
},
        handleExitSplitShipment(payload) {
    this.$store.commit('splitShipment/setSplitShipment', false);
    this.split_shipment_step = null;
    
    this.$nextTick(() => {
        const shippingComp = this.$children.find(c => c.$options.name === 'ShippingPayment');
        if (shippingComp) {
            shippingComp.shipping_option = payload.selectedOption;
        }
    });
},
        manageUpperThreeLinks(type) {
            var _this = this;
            if (type == "shipping_billing") {
                _this.is_reviewpay = false;
                _this.is_payment = false;
            } else if (type == "payment_shipment") {
                _this.is_reviewpay = false;
                _this.is_payment = true;
            } else if (type == "review_pay") {
                _this.is_reviewpay = true;
                _this.is_payment = false;
            }
        },
        getStates() {
            var _this = this;
            new Promise(() => {
                ApiService.get("/states")
                    .then(({ data }) => {
                        _this.all_states = data.states;
                    })
                    .catch(({ response }) => {
                        console.log(response.status);
                        if (response.status == 401) {
                            _this.$router.push({ name: "/admin/login" });
                        }
                    });
            });
        },
        getAddresses() {
            var _this = this;
            new Promise(() => {
                ApiService.get("/addresses")
                    .then(({ data }) => {
                        _this.all_address = data.address;
                    })
                    .catch(({ response }) => {
                        console.log(response.status);
                        if (response.status == 401) {
                            _this.$router.push({ name: "/admin/login" });
                        }
                    });
            });
        },

        /**
         * Ensure name_and_number_json (includes selected_name_number), font_color_sizes_name,
         * font_color_sizes_number are explicitly set on each item and subItem so they are
         * never dropped by JSON.stringify when sending to placeordernew.
         */
        prepareItemsForPlaceOrder(cartItems) {
            if (!Array.isArray(cartItems)) return cartItems;
            return cartItems.map((item) => {
                const base = {
                    ...item,
                    name_and_number_json:
                        item.name_and_number_json !== undefined
                            ? item.name_and_number_json
                            : null,
                    font_color_sizes_name:
                        item.font_color_sizes_name !== undefined &&
                        item.font_color_sizes_name !== ""
                            ? item.font_color_sizes_name
                            : null,
                    font_color_sizes_number:
                        item.font_color_sizes_number !== undefined &&
                        item.font_color_sizes_number !== ""
                            ? item.font_color_sizes_number
                            : null
                };
                if (base.subItems && Array.isArray(base.subItems)) {
                    base.subItems = base.subItems.map((sub) => ({
                        ...sub,
                        name_and_number_json:
                            sub.name_and_number_json !== undefined
                                ? sub.name_and_number_json
                                : item.name_and_number_json !== undefined
                                  ? item.name_and_number_json
                                  : null,
                        font_color_sizes_name:
                            sub.font_color_sizes_name !== undefined &&
                            sub.font_color_sizes_name !== ""
                                ? sub.font_color_sizes_name
                                : item.font_color_sizes_name !== undefined &&
                                  item.font_color_sizes_name !== ""
                                  ? item.font_color_sizes_name
                                  : null,
                        font_color_sizes_number:
                            sub.font_color_sizes_number !== undefined &&
                            sub.font_color_sizes_number !== ""
                                ? sub.font_color_sizes_number
                                : item.font_color_sizes_number !== undefined &&
                                  item.font_color_sizes_number !== ""
                                  ? item.font_color_sizes_number
                                  : null
                    }));
                }
                return base;
            });
        },
        syncPatchDetailsForPlaceOrder(cartItems) {
            if (!Array.isArray(cartItems)) return;
            const summary = this.$refs.cartSummaryRef;
            if (!summary || typeof summary.getDynamicPatchCostContext !== "function") {
                return;
            }

            cartItems.forEach((item) => {
                const ctx = summary.getDynamicPatchCostContext(item);
                if (ctx && Array.isArray(ctx.details)) {
                    item.patch_cost_details = ctx.details;
                    item.patch_cost = ctx.total;
                }

                if (Array.isArray(item.subItems)) {
                    item.subItems.forEach((subItem) => {
                        const subCtx = summary.getDynamicPatchCostContext(subItem);
                        if (subCtx && Array.isArray(subCtx.details)) {
                            subItem.patch_cost_details = subCtx.details;
                            subItem.patch_cost = subCtx.total;
                        }
                    });
                }
            });
        },
        placeOrder() {
            var _this = this;

            // Prevent duplicate order placement
            if (_this.isLoader || _this.placingOrder) {
                console.log(
                    "Order placement already in progress, ignoring duplicate call"
                );
                return;
            }

            _this.placingOrder = true;
            // Use calculatedGrandTotal instead of grand_total for accurate total_price
            _this.order_data.total_price =
                _this.$refs.cartSummaryRef.calculatedGrandTotal;
            // Use getShippingTotal() to include shipping method charge + shipping services
            _this.order_data.shipping_price =
                _this.$refs.cartSummaryRef.getShippingTotal();
            _this.order_data.total_setup_fees =
                _this.$refs.cartSummaryRef.total_setup_fee;
            _this.order_data.total_color_fees =
                _this.$refs.cartSummaryRef.total_imprint_locations_price;

            // Use calculatedGrandTotal which already includes all fees (base, run charge, color mix, setup, non-standard), shipping, and sales tax
            const calculatedGrandTotal =
                _this.$refs.cartSummaryRef.calculatedGrandTotal;
            _this.order_data.grand_total_price =
                calculatedGrandTotal.toFixed(2);
            _this.order_data.order_price = parseFloat(
                calculatedGrandTotal.toFixed(2)
            );
            _this.order_data.total_quantity =
                _this.$refs.cartSummaryRef.total_quantity;

            // Ensure displayData breakdowns are available in cart_items before sending
            let cart_items = _this.$refs.cartSummaryRef.cart_items;
            if (cart_items && cart_items.length > 0) {
                _this.syncPatchDetailsForPlaceOrder(cart_items);
                cart_items.forEach((item) => {
                    // Recalculate displayData to ensure breakdowns are fresh
                    const freshDisplayData =
                        _this.$refs.cartSummaryRef.getItemDisplayData(item);
                    if (freshDisplayData) {
                        item.displayData = freshDisplayData;

                        // Get quantity for calculating service prices
                        const quantity =
                            freshDisplayData.quantity ||
                            _this.$refs.cartSummaryRef.getTotalItemQuantity(
                                item
                            );

                        // Add other services to runChargeBreakdown (rollup_fee_id = 12)
                        let runChargeBreakdown =
                            freshDisplayData.runChargeBreakdown || [];
                        if (
                            freshDisplayData.runChargeServices &&
                            freshDisplayData.runChargeServices.length > 0
                        ) {
                            // Deep copy to avoid modifying original
                            runChargeBreakdown = JSON.parse(
                                JSON.stringify(runChargeBreakdown)
                            );
                            freshDisplayData.runChargeServices.forEach(
                                (service) => {
                                    const servicePrice =
                                        service.retail_cost ||
                                        service.net_cost ||
                                        0;
                                    let serviceTotal = 0;
                                    if (service.fee_structure === "Per Item") {
                                        serviceTotal =
                                            parseFloat(servicePrice) * quantity;
                                    } else {
                                        serviceTotal = parseFloat(servicePrice);
                                    }
                                    if (serviceTotal > 0) {
                                        // Get service name from various possible locations
                                        const serviceName =
                                            service.service_name ||
                                            (service.master_service &&
                                                service.master_service
                                                    .service_name) ||
                                            service.name ||
                                            service.ecomm_display ||
                                            "Other Service";
                                        // Get service ID from various possible locations
                                        const serviceId =
                                            service.service_id ||
                                            service.id ||
                                            (service.master_service &&
                                                service.master_service.id) ||
                                            null;
                                        runChargeBreakdown.push({
                                            type: "otherService",
                                            name: serviceName,
                                            qty:
                                                service.fee_structure ===
                                                "Per Item"
                                                    ? quantity
                                                    : 1,
                                            amt: servicePrice,
                                            total: serviceTotal,
                                            service_id: serviceId,
                                            rollup_fee_id: 12
                                        });
                                    }
                                }
                            );
                        }
                        item.displayData.runChargeBreakdown =
                            runChargeBreakdown;
                        item.runChargeBreakdown = runChargeBreakdown;

                        // Add other services to setup_fees_details (rollup_fee_id = 2)
                        let setupFeesDetails = item.setup_fees_details || null;
                        if (
                            freshDisplayData.setupFeeServices &&
                            freshDisplayData.setupFeeServices.length > 0
                        ) {
                            // Deep copy to avoid modifying original
                            if (setupFeesDetails) {
                                setupFeesDetails = JSON.parse(
                                    JSON.stringify(setupFeesDetails)
                                );
                            } else {
                                setupFeesDetails = {
                                    locations: [],
                                    total: 0,
                                    services: []
                                };
                            }

                            // Initialize services array if not exists
                            if (!setupFeesDetails.services) {
                                setupFeesDetails.services = [];
                            }

                            let setupServicesTotal = 0;
                            freshDisplayData.setupFeeServices.forEach(
                                (service) => {
                                    const servicePrice =
                                        service.retail_cost ||
                                        service.net_cost ||
                                        0;
                                    let serviceTotal = 0;
                                    if (service.fee_structure === "Per Item") {
                                        serviceTotal =
                                            parseFloat(servicePrice) * quantity;
                                    } else {
                                        serviceTotal = parseFloat(servicePrice);
                                    }
                                    if (serviceTotal > 0) {
                                        // Get service name from various possible locations
                                        const serviceName =
                                            service.service_name ||
                                            (service.master_service &&
                                                service.master_service
                                                    .service_name) ||
                                            service.name ||
                                            service.ecomm_display ||
                                            "Other Service";
                                        // Get service ID from various possible locations
                                        const serviceId =
                                            service.service_id ||
                                            service.id ||
                                            (service.master_service &&
                                                service.master_service.id) ||
                                            null;
                                        setupFeesDetails.services.push({
                                            service_id: serviceId,
                                            service_name: serviceName,
                                            fee_structure:
                                                service.fee_structure,
                                            retail_cost: servicePrice,
                                            net_cost: service.net_cost || 0,
                                            quantity:
                                                service.fee_structure ===
                                                "Per Item"
                                                    ? quantity
                                                    : 1,
                                            total: serviceTotal,
                                            rollup_fee_id: 2
                                        });
                                        setupServicesTotal += serviceTotal;
                                    }
                                }
                            );

                            // Update total in setup_fees_details
                            const existingTotal = parseFloat(
                                setupFeesDetails.total || 0
                            );
                            setupFeesDetails.total = (
                                existingTotal + setupServicesTotal
                            ).toFixed(2);
                        }
                        item.setup_fees_details = setupFeesDetails;

                        // Ensure rushFeeBreakdown is properly set from displayData
                        let rushFeeBreakdown = item.rush_fee_breakdown || null;
                        if (freshDisplayData.rushFeeBreakdown) {
                            rushFeeBreakdown =
                                freshDisplayData.rushFeeBreakdown;
                        } else if (
                            freshDisplayData.rushFeeServices &&
                            freshDisplayData.rushFeeServices.length > 0
                        ) {
                            // If rushFeeBreakdown doesn't exist but rushFeeServices do, create breakdown structure
                            rushFeeBreakdown = {
                                services: freshDisplayData.rushFeeServices.map(
                                    (service) => {
                                        // Check if it's a rush option and determine fee_structure and quantity
                                        const isRushOption =
                                            service.is_rush_option === true;
                                        const serviceId =
                                            service.service_id ||
                                            service.id ||
                                            null;
                                        const isRushPackage =
                                            isRushOption &&
                                            serviceId === "rush_package";

                                        // Set fee_structure: rush_package = "Per Order", others = "Per Item"
                                        const feeStructure = isRushPackage
                                            ? "Per Order"
                                            : isRushOption
                                            ? "Per Item"
                                            : service.fee_structure ||
                                              "Per Order";

                                        // Set quantity: rush_package = 1, others = actual quantity
                                        const serviceQuantity = isRushPackage
                                            ? 1
                                            : isRushOption
                                            ? quantity
                                            : service.fee_structure ===
                                              "Per Item"
                                            ? quantity
                                            : 1;

                                        // Calculate retail_cost
                                        const retailCost = parseFloat(
                                            service.retail_cost ||
                                                service.net_cost ||
                                                0
                                        );

                                        // Calculate total: retail_cost * quantity
                                        const serviceTotal =
                                            retailCost * serviceQuantity;

                                        return {
                                            name:
                                                service.service_name ||
                                                service.name ||
                                                service.ecomm_display ||
                                                "Rush Service",
                                            service_name:
                                                service.service_name ||
                                                service.name ||
                                                service.ecomm_display ||
                                                "Rush Service",
                                            service_id: serviceId,
                                            retail_cost: retailCost,
                                            net_cost: parseFloat(
                                                service.net_cost || 0
                                            ),
                                            quantity: serviceQuantity,
                                            qty: serviceQuantity,
                                            total: serviceTotal,
                                            fee_structure: feeStructure,
                                            rollup_fee_id: 6,
                                            is_rush_option: isRushOption
                                        };
                                    }
                                )
                            };
                        }
                        item.displayData.rushFeeBreakdown = rushFeeBreakdown;
                        item.rushFeeBreakdown = rushFeeBreakdown;
                        item.rush_fee_breakdown = rushFeeBreakdown;

                        // Ensure baseFeeBreakdown is properly set (always set, even if null)
                        item.displayData.baseFeeBreakdown =
                            freshDisplayData.baseFeeBreakdown || null;
                        item.baseFeeBreakdown =
                            freshDisplayData.baseFeeBreakdown || null;

                        // Ensure customColorBreakdown is properly set (always set, even if null)
                        // For grouped items, use getCombinedColorMixFeeData and getCombinedColorMixFeeServices
                        // to create proper breakdown array using getCustomColorBreakdown
                        let customColorBreakdown = null;
                        if (
                            _this.$refs.cartSummaryRef.isGroupedDecorationType0(
                                item
                            )
                        ) {
                            // For grouped items, get combined data and services, then create breakdown
                            const combinedColorMixFeeData =
                                _this.$refs.cartSummaryRef.getCombinedColorMixFeeData(
                                    item
                                );
                            const combinedColorMixFeeServices =
                                _this.$refs.cartSummaryRef.getCombinedColorMixFeeServices(
                                    item
                                );

                            if (
                                combinedColorMixFeeData ||
                                (combinedColorMixFeeServices &&
                                    combinedColorMixFeeServices.length > 0)
                            ) {
                                // Use getCustomColorBreakdown to create proper breakdown array format
                                customColorBreakdown =
                                    _this.$refs.cartSummaryRef.getCustomColorBreakdown(
                                        item,
                                        combinedColorMixFeeData,
                                        combinedColorMixFeeServices,
                                        quantity
                                    );
                            }
                        } else {
                            // For non-grouped items, use regular custom color fee data
                            customColorBreakdown =
                                freshDisplayData.customColorBreakdown || null;
                        }
                        item.displayData.customColorBreakdown =
                            customColorBreakdown;
                        item.customColorBreakdown = customColorBreakdown;
                    }
                    // Also ensure subItems have displayData
                    if (item.subItems && item.subItems.length > 0) {
                        item.subItems.forEach((subItem) => {
                            const freshSubDisplayData =
                                _this.$refs.cartSummaryRef.getItemDisplayData(
                                    subItem,
                                    item
                                );
                            if (freshSubDisplayData) {
                                // Deep copy to avoid Vue reactivity issues
                                subItem.displayData = JSON.parse(
                                    JSON.stringify(freshSubDisplayData)
                                );

                                // Get quantity for calculating service prices
                                const subQuantity =
                                    freshSubDisplayData.quantity ||
                                    _this.$refs.cartSummaryRef.getTotalItemQuantity(
                                        subItem
                                    );

                                // Add other services to runChargeBreakdown for subItems (rollup_fee_id = 12)
                                let subRunChargeBreakdown =
                                    freshSubDisplayData.runChargeBreakdown ||
                                    [];
                                if (
                                    freshSubDisplayData.runChargeServices &&
                                    freshSubDisplayData.runChargeServices
                                        .length > 0
                                ) {
                                    // Deep copy to avoid modifying original
                                    subRunChargeBreakdown = JSON.parse(
                                        JSON.stringify(subRunChargeBreakdown)
                                    );
                                    freshSubDisplayData.runChargeServices.forEach(
                                        (service) => {
                                            const servicePrice =
                                                service.retail_cost ||
                                                service.net_cost ||
                                                0;
                                            let serviceTotal = 0;
                                            if (
                                                service.fee_structure ===
                                                "Per Item"
                                            ) {
                                                serviceTotal =
                                                    parseFloat(servicePrice) *
                                                    subQuantity;
                                            } else {
                                                serviceTotal =
                                                    parseFloat(servicePrice);
                                            }
                                            if (serviceTotal > 0) {
                                                // Get service name from various possible locations
                                                const serviceName =
                                                    service.service_name ||
                                                    (service.master_service &&
                                                        service.master_service
                                                            .service_name) ||
                                                    service.name ||
                                                    service.ecomm_display ||
                                                    "Other Service";
                                                // Get service ID from various possible locations
                                                const serviceId =
                                                    service.service_id ||
                                                    service.id ||
                                                    (service.master_service &&
                                                        service.master_service
                                                            .id) ||
                                                    null;
                                                subRunChargeBreakdown.push({
                                                    type: "otherService",
                                                    name: serviceName,
                                                    qty:
                                                        service.fee_structure ===
                                                        "Per Item"
                                                            ? subQuantity
                                                            : 1,
                                                    amt: servicePrice,
                                                    total: serviceTotal,
                                                    service_id: serviceId,
                                                    rollup_fee_id: 12
                                                });
                                            }
                                        }
                                    );
                                }
                                subItem.displayData.runChargeBreakdown =
                                    subRunChargeBreakdown;
                                subItem.runChargeBreakdown =
                                    subRunChargeBreakdown;

                                // Add other services to setup_fees_details for subItems (rollup_fee_id = 2)
                                let subSetupFeesDetails =
                                    subItem.setup_fees_details || null;
                                if (
                                    freshSubDisplayData.setupFeeServices &&
                                    freshSubDisplayData.setupFeeServices
                                        .length > 0
                                ) {
                                    // Deep copy to avoid modifying original
                                    if (subSetupFeesDetails) {
                                        subSetupFeesDetails = JSON.parse(
                                            JSON.stringify(subSetupFeesDetails)
                                        );
                                    } else {
                                        subSetupFeesDetails = {
                                            locations: [],
                                            total: 0,
                                            services: []
                                        };
                                    }

                                    // Initialize services array if not exists
                                    if (!subSetupFeesDetails.services) {
                                        subSetupFeesDetails.services = [];
                                    }

                                    let subSetupServicesTotal = 0;
                                    freshSubDisplayData.setupFeeServices.forEach(
                                        (service) => {
                                            const servicePrice =
                                                service.retail_cost ||
                                                service.net_cost ||
                                                0;
                                            let serviceTotal = 0;
                                            if (
                                                service.fee_structure ===
                                                "Per Item"
                                            ) {
                                                serviceTotal =
                                                    parseFloat(servicePrice) *
                                                    subQuantity;
                                            } else {
                                                serviceTotal =
                                                    parseFloat(servicePrice);
                                            }
                                            if (serviceTotal > 0) {
                                                // Get service name from various possible locations
                                                const serviceName =
                                                    service.service_name ||
                                                    (service.master_service &&
                                                        service.master_service
                                                            .service_name) ||
                                                    service.name ||
                                                    service.ecomm_display ||
                                                    "Other Service";
                                                // Get service ID from various possible locations
                                                const serviceId =
                                                    service.service_id ||
                                                    service.id ||
                                                    (service.master_service &&
                                                        service.master_service
                                                            .id) ||
                                                    null;
                                                subSetupFeesDetails.services.push(
                                                    {
                                                        service_id: serviceId,
                                                        service_name:
                                                            serviceName,
                                                        fee_structure:
                                                            service.fee_structure,
                                                        retail_cost:
                                                            servicePrice,
                                                        net_cost:
                                                            service.net_cost ||
                                                            0,
                                                        quantity:
                                                            service.fee_structure ===
                                                            "Per Item"
                                                                ? subQuantity
                                                                : 1,
                                                        total: serviceTotal,
                                                        rollup_fee_id: 2
                                                    }
                                                );
                                                subSetupServicesTotal +=
                                                    serviceTotal;
                                            }
                                        }
                                    );

                                    // Update total in setup_fees_details
                                    const existingSubTotal = parseFloat(
                                        subSetupFeesDetails.total || 0
                                    );
                                    subSetupFeesDetails.total = (
                                        existingSubTotal + subSetupServicesTotal
                                    ).toFixed(2);
                                }
                                subItem.setup_fees_details =
                                    subSetupFeesDetails;

                                // Ensure rushFeeBreakdown for subItems is properly set from displayData
                                let subRushFeeBreakdown =
                                    subItem.rush_fee_breakdown || null;
                                if (freshSubDisplayData.rushFeeBreakdown) {
                                    subRushFeeBreakdown =
                                        freshSubDisplayData.rushFeeBreakdown;
                                } else if (
                                    freshSubDisplayData.rushFeeServices &&
                                    freshSubDisplayData.rushFeeServices.length >
                                        0
                                ) {
                                    // If rushFeeBreakdown doesn't exist but rushFeeServices do, create breakdown structure
                                    subRushFeeBreakdown = {
                                        services:
                                            freshSubDisplayData.rushFeeServices.map(
                                                (service) => {
                                                    // Check if it's a rush option and determine fee_structure and quantity
                                                    const isRushOption =
                                                        service.is_rush_option ===
                                                        true;
                                                    const serviceId =
                                                        service.service_id ||
                                                        service.id ||
                                                        null;
                                                    const isRushPackage =
                                                        isRushOption &&
                                                        serviceId ===
                                                            "rush_package";

                                                    // Set fee_structure: rush_package = "Per Order", others = "Per Item"
                                                    const feeStructure =
                                                        isRushPackage
                                                            ? "Per Order"
                                                            : isRushOption
                                                            ? "Per Item"
                                                            : service.fee_structure ||
                                                              "Per Order";

                                                    // Set quantity: rush_package = 1, others = actual quantity
                                                    const serviceQuantity =
                                                        isRushPackage
                                                            ? 1
                                                            : isRushOption
                                                            ? subQuantity
                                                            : service.fee_structure ===
                                                              "Per Item"
                                                            ? subQuantity
                                                            : 1;

                                                    // Calculate retail_cost
                                                    const retailCost =
                                                        parseFloat(
                                                            service.retail_cost ||
                                                                service.net_cost ||
                                                                0
                                                        );

                                                    // Calculate total: retail_cost * quantity
                                                    const serviceTotal =
                                                        retailCost *
                                                        serviceQuantity;

                                                    return {
                                                        name:
                                                            service.service_name ||
                                                            service.name ||
                                                            service.ecomm_display ||
                                                            "Rush Service",
                                                        service_name:
                                                            service.service_name ||
                                                            service.name ||
                                                            service.ecomm_display ||
                                                            "Rush Service",
                                                        service_id: serviceId,
                                                        retail_cost: retailCost,
                                                        net_cost: parseFloat(
                                                            service.net_cost ||
                                                                0
                                                        ),
                                                        quantity:
                                                            serviceQuantity,
                                                        qty: serviceQuantity,
                                                        total: serviceTotal,
                                                        fee_structure:
                                                            feeStructure,
                                                        rollup_fee_id: 6,
                                                        is_rush_option:
                                                            isRushOption
                                                    };
                                                }
                                            )
                                    };
                                }
                                subItem.displayData.rushFeeBreakdown =
                                    subRushFeeBreakdown;
                                subItem.rushFeeBreakdown = subRushFeeBreakdown;
                                subItem.rush_fee_breakdown =
                                    subRushFeeBreakdown;

                                // Ensure baseFeeBreakdown for subItems (always set, even if null)
                                subItem.displayData.baseFeeBreakdown =
                                    freshSubDisplayData.baseFeeBreakdown ||
                                    null;
                                subItem.baseFeeBreakdown =
                                    freshSubDisplayData.baseFeeBreakdown ||
                                    null;

                                // Custom color: combined mix on parent; sub lines still carry rollup-13 "other" rows (e.g. poly bag)
                                subItem.displayData.customColorBreakdown =
                                    freshSubDisplayData.customColorBreakdown ||
                                    null;
                                subItem.customColorBreakdown =
                                    freshSubDisplayData.customColorBreakdown ||
                                    null;
                            }
                        });
                    }
                });
            }

            // Get shipping breakdown data from CartSummary
            _this.order_data.shipping_cost_breakdown =
                _this.$refs.cartSummaryRef.getShippingBreakdown();

            // Get packaging breakdown data from CartSummary
            _this.order_data.packaging_kitting_handling_breakdown =
                _this.$refs.cartSummaryRef.getPackagingBreakdown();

            // Get sales tax breakdown data from CartSummary
            _this.order_data.sales_tax_breakdown =
                _this.$refs.cartSummaryRef.getSalesTaxBreakdown();

            // Use getSalesTaxTotal() to include sales tax from order_data + sales tax services
            _this.order_data.sales_tax =
                _this.$refs.cartSummaryRef.getSalesTaxTotal();

            // Add discount value and item_sub_total to each item and subItem before sending to backend
            // Note: Discount is now applied at size cost level, so item_discount will always be 0
            if (cart_items && cart_items.length > 0) {
                cart_items.forEach((item) => {
                    // Discount removed - discount is now applied at size cost level
                    // getItemDiscount always returns 0 now
                    const itemDiscount =
                        _this.$refs.cartSummaryRef.getItemDiscount(item);
                    item.item_discount = parseFloat(itemDiscount || 0);

                    // Add estimated_shipping_date from frontend calculation (user's local timezone)
                    // This ensures the date saved in database matches what user sees on screen
                    if (_this.$refs.cartSummaryRef.getEstimatedShippingDate) {
                        const estimatedDateStr =
                            _this.$refs.cartSummaryRef.getEstimatedShippingDate(
                                item
                            );
                        if (estimatedDateStr) {
                            // Convert MM/DD/YYYY to YYYY-MM-DD format for backend
                            const [month, day, year] =
                                estimatedDateStr.split("/");
                            item.estimated_shipping_date = `${year}-${month.padStart(
                                2,
                                "0"
                            )}-${day.padStart(2, "0")}`;
                        }
                    }

                    // Add item_sub_total for main item
                    // For grouped decoration type 0 items, use getItemSubTotalForGroupedParent
                    if (
                        _this.$refs.cartSummaryRef.isGroupedDecorationType0 &&
                        _this.$refs.cartSummaryRef.isGroupedDecorationType0(
                            item
                        ) &&
                        item.subItems &&
                        item.subItems.length > 0
                    ) {
                        // For grouped parent items, use getItemSubTotalForGroupedParent (includes combined color mix fee)
                        if (
                            _this.$refs.cartSummaryRef
                                .getItemSubTotalForGroupedParent
                        ) {
                            item.item_sub_total = parseFloat(
                                _this.$refs.cartSummaryRef.getItemSubTotalForGroupedParent(
                                    item
                                ) || 0
                            );
                        }
                    } else {
                        // For single items, use getItemSubTotal
                        if (_this.$refs.cartSummaryRef.getItemSubTotal) {
                            item.item_sub_total = parseFloat(
                                _this.$refs.cartSummaryRef.getItemSubTotal(
                                    item
                                ) || 0
                            );
                        } else if (
                            item.displayData &&
                            item.displayData.itemSubTotal !== undefined
                        ) {
                            item.item_sub_total = parseFloat(
                                item.displayData.itemSubTotal || 0
                            );
                        }
                    }

                    // Add discount value and item_sub_total for subItems
                    // Note: Discount is now applied at size cost level, so item_discount will always be 0
                    if (item.subItems && item.subItems.length > 0) {
                        item.subItems.forEach((subItem) => {
                            // Discount removed - discount is now applied at size cost level
                            const subItemDiscount =
                                _this.$refs.cartSummaryRef.getItemDiscount(
                                    subItem,
                                    item
                                );
                            subItem.item_discount = parseFloat(
                                subItemDiscount || 0
                            );

                            // For subItems, use getSubItemSubTotal (excludes color mix fee for grouped items)
                            if (_this.$refs.cartSummaryRef.getSubItemSubTotal) {
                                subItem.item_sub_total = parseFloat(
                                    _this.$refs.cartSummaryRef.getSubItemSubTotal(
                                        subItem,
                                        item
                                    ) || 0
                                );
                            } else if (
                                _this.$refs.cartSummaryRef.getItemSubTotal
                            ) {
                                // Fallback: try to get from Cart component via getItemSubTotal
                                subItem.item_sub_total = parseFloat(
                                    _this.$refs.cartSummaryRef.getItemSubTotal(
                                        subItem,
                                        item
                                    ) || 0
                                );
                            } else if (
                                subItem.displayData &&
                                subItem.displayData.itemSubTotal !== undefined
                            ) {
                                subItem.item_sub_total = parseFloat(
                                    subItem.displayData.itemSubTotal || 0
                                );
                            }
                        });
                    }
                });
            }

            // Ensure unit_price has discount applied before sending to backend
            // Recalculate pricing to ensure unit_price has discount applied
            if (
                _this.$refs.cartSummaryRef &&
                _this.$refs.cartSummaryRef.$parent &&
                _this.$refs.cartSummaryRef.$parent.calculatePricing
            ) {
                _this.$refs.cartSummaryRef.$parent.calculatePricing(cart_items);
            }

            // Extract unit price from baseFeeBreakdown (which has correct discounted prices from CartSummary)
            if (cart_items && cart_items.length > 0) {
                cart_items.forEach((item) => {
                    const baseFeeBreakdown =
                        item.baseFeeBreakdown ||
                        (item.displayData &&
                            item.displayData.baseFeeBreakdown) ||
                        null;

                    if (item.CartChildItems && item.CartChildItems.length > 0) {
                        item.CartChildItems.forEach((childItem) => {
                            let unitPriceFromBreakdown = null;
                            const originalUnitPrice = parseFloat(
                                childItem.unit_price || 0
                            );

                            if (
                                baseFeeBreakdown &&
                                Array.isArray(baseFeeBreakdown) &&
                                baseFeeBreakdown.length > 0
                            ) {
                                const childQty = parseInt(
                                    childItem.quantity || 0
                                );
                                const sizeObj =
                                    childItem.main_new_sub_product &&
                                    childItem.main_new_sub_product.Size;
                                let sizeAbbr = null;
                                if (sizeObj) {
                                    if (sizeObj.size_name) {
                                        sizeAbbr = sizeObj.size_name;
                                    } else if (sizeObj.size) {
                                        const sizeParts = sizeObj.size
                                            .trim()
                                            .split(/\s+/);
                                        sizeAbbr =
                                            sizeParts[sizeParts.length - 1];
                                    } else if (sizeObj.name) {
                                        const nameParts = sizeObj.name
                                            .trim()
                                            .split(/\s+/);
                                        sizeAbbr =
                                            nameParts[nameParts.length - 1];
                                    }
                                }

                                const matchingEntries = baseFeeBreakdown.filter(
                                    (entry) => {
                                        if (entry.type !== "colorSize") {
                                            return false;
                                        }
                                        const entryQty = parseInt(
                                            entry.qty || 0
                                        );
                                        return entryQty === childQty;
                                    }
                                );

                                console.log(
                                    "[Checkout] Main Item - Matching Entries:",
                                    {
                                        decorationType: item.decoration_type,
                                        sizeAbbr: sizeAbbr,
                                        childQty: childQty,
                                        matchingEntriesCount:
                                            matchingEntries.length,
                                        matchingEntries: matchingEntries.map(
                                            (e) => ({
                                                name: e.name,
                                                amt: e.amt,
                                                qty: e.qty
                                            })
                                        )
                                    }
                                );

                                if (matchingEntries.length === 1) {
                                    unitPriceFromBreakdown = parseFloat(
                                        matchingEntries[0].amt || 0
                                    );
                                } else if (
                                    matchingEntries.length > 1 &&
                                    sizeAbbr
                                ) {
                                    const sizeMatch = matchingEntries.find(
                                        (entry) => {
                                            const entryName = entry.name || "";
                                            const searchSize =
                                                sizeAbbr.toUpperCase();
                                            const entryNameUpper =
                                                entryName.toUpperCase();

                                            if (
                                                entryNameUpper.endsWith(
                                                    ` - ${searchSize}`
                                                ) ||
                                                entryNameUpper.endsWith(
                                                    `- ${searchSize}`
                                                )
                                            ) {
                                                return true;
                                            }

                                            const sizeFromName = entryName
                                                .split(/-/)
                                                .pop()
                                                .trim()
                                                .toUpperCase();
                                            return sizeFromName === searchSize;
                                        }
                                    );
                                    if (sizeMatch) {
                                        unitPriceFromBreakdown = parseFloat(
                                            sizeMatch.amt || 0
                                        );
                                        console.log(
                                            "[Checkout] Main Item - Size Match Found:",
                                            {
                                                sizeAbbr: sizeAbbr,
                                                matchedEntry: {
                                                    name: sizeMatch.name,
                                                    amt: sizeMatch.amt
                                                }
                                            }
                                        );
                                    } else {
                                        console.log(
                                            "[Checkout] Main Item - No Size Match, using first entry:",
                                            {
                                                sizeAbbr: sizeAbbr,
                                                allEntries: matchingEntries.map(
                                                    (e) => e.name
                                                )
                                            }
                                        );
                                        if (matchingEntries.length > 0) {
                                            unitPriceFromBreakdown = parseFloat(
                                                matchingEntries[0].amt || 0
                                            );
                                        }
                                    }
                                }

                                console.log(
                                    "[Checkout] Main Item - Decoration Type:",
                                    item.decoration_type,
                                    "| Size:",
                                    sizeAbbr,
                                    "| Qty:",
                                    childQty,
                                    "| Original Unit Price:",
                                    originalUnitPrice,
                                    "| Breakdown Unit Price:",
                                    unitPriceFromBreakdown,
                                    "| Final Unit Price:",
                                    unitPriceFromBreakdown || originalUnitPrice
                                );
                            }

                            if (
                                unitPriceFromBreakdown !== null &&
                                unitPriceFromBreakdown > 0
                            ) {
                                childItem.unit_price = unitPriceFromBreakdown;
                            }
                        });
                    }

                    // Also check subItems
                    if (item.subItems && item.subItems.length > 0) {
                        item.subItems.forEach((subItem) => {
                            const subBaseFeeBreakdown =
                                subItem.baseFeeBreakdown ||
                                (subItem.displayData &&
                                    subItem.displayData.baseFeeBreakdown) ||
                                null;

                            if (
                                subItem.CartChildItems &&
                                subItem.CartChildItems.length > 0
                            ) {
                                subItem.CartChildItems.forEach((childItem) => {
                                    let unitPriceFromBreakdown = null;
                                    const originalUnitPrice = parseFloat(
                                        childItem.unit_price || 0
                                    );

                                    if (
                                        subBaseFeeBreakdown &&
                                        Array.isArray(subBaseFeeBreakdown) &&
                                        subBaseFeeBreakdown.length > 0
                                    ) {
                                        const childQty = parseInt(
                                            childItem.quantity || 0
                                        );
                                        const sizeObj =
                                            childItem.main_new_sub_product &&
                                            childItem.main_new_sub_product.Size;
                                        let sizeAbbr = null;
                                        if (sizeObj) {
                                            if (sizeObj.size_name) {
                                                sizeAbbr = sizeObj.size_name;
                                            } else if (sizeObj.size) {
                                                const sizeParts = sizeObj.size
                                                    .trim()
                                                    .split(/\s+/);
                                                sizeAbbr =
                                                    sizeParts[
                                                        sizeParts.length - 1
                                                    ];
                                            } else if (sizeObj.name) {
                                                const nameParts = sizeObj.name
                                                    .trim()
                                                    .split(/\s+/);
                                                sizeAbbr =
                                                    nameParts[
                                                        nameParts.length - 1
                                                    ];
                                            }
                                        }

                                        const matchingEntries =
                                            subBaseFeeBreakdown.filter(
                                                (entry) => {
                                                    if (
                                                        entry.type !==
                                                        "colorSize"
                                                    ) {
                                                        return false;
                                                    }
                                                    const entryQty = parseInt(
                                                        entry.qty || 0
                                                    );
                                                    return (
                                                        entryQty === childQty
                                                    );
                                                }
                                            );

                                        console.log(
                                            "[Checkout] Sub Item - Matching Entries:",
                                            {
                                                decorationType:
                                                    subItem.decoration_type,
                                                sizeAbbr: sizeAbbr,
                                                childQty: childQty,
                                                matchingEntriesCount:
                                                    matchingEntries.length,
                                                matchingEntries:
                                                    matchingEntries.map(
                                                        (e) => ({
                                                            name: e.name,
                                                            amt: e.amt,
                                                            qty: e.qty
                                                        })
                                                    )
                                            }
                                        );

                                        if (matchingEntries.length === 1) {
                                            unitPriceFromBreakdown = parseFloat(
                                                matchingEntries[0].amt || 0
                                            );
                                        } else if (
                                            matchingEntries.length > 1 &&
                                            sizeAbbr
                                        ) {
                                            const sizeMatch =
                                                matchingEntries.find(
                                                    (entry) => {
                                                        const entryName =
                                                            entry.name || "";
                                                        const searchSize =
                                                            sizeAbbr.toUpperCase();
                                                        const entryNameUpper =
                                                            entryName.toUpperCase();

                                                        if (
                                                            entryNameUpper.endsWith(
                                                                ` - ${searchSize}`
                                                            ) ||
                                                            entryNameUpper.endsWith(
                                                                `- ${searchSize}`
                                                            )
                                                        ) {
                                                            return true;
                                                        }

                                                        const sizeFromName =
                                                            entryName
                                                                .split(/-/)
                                                                .pop()
                                                                .trim()
                                                                .toUpperCase();
                                                        return (
                                                            sizeFromName ===
                                                            searchSize
                                                        );
                                                    }
                                                );
                                            if (sizeMatch) {
                                                unitPriceFromBreakdown =
                                                    parseFloat(
                                                        sizeMatch.amt || 0
                                                    );
                                                console.log(
                                                    "[Checkout] Sub Item - Size Match Found:",
                                                    {
                                                        sizeAbbr: sizeAbbr,
                                                        matchedEntry: {
                                                            name: sizeMatch.name,
                                                            amt: sizeMatch.amt
                                                        }
                                                    }
                                                );
                                            } else {
                                                console.log(
                                                    "[Checkout] Sub Item - No Size Match, using first entry:",
                                                    {
                                                        sizeAbbr: sizeAbbr,
                                                        allEntries:
                                                            matchingEntries.map(
                                                                (e) => e.name
                                                            )
                                                    }
                                                );
                                                if (
                                                    matchingEntries.length > 0
                                                ) {
                                                    unitPriceFromBreakdown =
                                                        parseFloat(
                                                            matchingEntries[0]
                                                                .amt || 0
                                                        );
                                                }
                                            }
                                        }

                                        console.log(
                                            "[Checkout] Sub Item - Decoration Type:",
                                            subItem.decoration_type,
                                            "| Size:",
                                            sizeAbbr,
                                            "| Qty:",
                                            childQty,
                                            "| Original Unit Price:",
                                            originalUnitPrice,
                                            "| Breakdown Unit Price:",
                                            unitPriceFromBreakdown,
                                            "| Final Unit Price:",
                                            unitPriceFromBreakdown ||
                                                originalUnitPrice
                                        );
                                    }

                                    if (
                                        unitPriceFromBreakdown !== null &&
                                        unitPriceFromBreakdown > 0
                                    ) {
                                        childItem.unit_price =
                                            unitPriceFromBreakdown;
                                    }
                                });
                            }
                        });
                    }
                });
            }

            // Ensure name_and_number_json, font_color_sizes_* are always on each item/subItem so backend main_new_order_items gets them
            _this.order_data.items =
                _this.prepareItemsForPlaceOrder(cart_items);
            if (localStorage.getItem("billingAddressIdAfterNewAddress")) {
                _this.order_data.billingaddressid = localStorage.getItem(
                    "billingAddressIdAfterNewAddress"
                );
            }
            if (localStorage.getItem("shippingAddressIdAfterNewAddress")) {
                _this.order_data.shippingaddressid = localStorage.getItem(
                    "shippingAddressIdAfterNewAddress"
                );
            }
            _this.isLoader = true;

            _this.order_data.balance_after_order =
                parseFloat(_this.term_payment_info.avalaible_on_account) -
                parseFloat(_this.order_data.grand_total_price);
            _this.order_data.term_payment_info = _this.term_payment_info;
            _this.order_data.admin_user_id =
                localStorage.getItem("admin_user_id");
            
            // Recompute delivery fields if they are missing.
            if (!_this.order_data.estimated_delivery_date && _this.selected_shiping_method && _this.selected_shiping_method.deliveryDate) {
                const currentDate = new Date();
                currentDate.setHours(0, 0, 0, 0);
                
                const deliveryDate = new Date(_this.selected_shiping_method.deliveryDate);
                deliveryDate.setHours(0, 0, 0, 0);
                
                const timeDiff = deliveryDate.getTime() - currentDate.getTime();
                const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
                
                const year = deliveryDate.getFullYear();
                const month = String(deliveryDate.getMonth() + 1).padStart(2, '0');
                const day = String(deliveryDate.getDate()).padStart(2, '0');
                const formattedDeliveryDate = `${year}-${month}-${day}`;
                
                _this.order_data.estimated_delivery_date = formattedDeliveryDate;
                _this.order_data.estimated_delivery_days = daysDiff > 0 ? daysDiff : 1;
            }
            new Promise(() => {
                ApiService.post("/placeordernew", _this.order_data)
                    .then(({ data }) => {
                        _this.isLoader = false;
                        _this.placingOrder = false;
                        const closeBtn = document.getElementById("popup-close-address");
                        if (closeBtn) {
                            closeBtn.click();
                        }
                        if (data.success) {
                            _this.$toast.success(data.message, {
                                position: "top-right"
                            });
                            _this.emptyCart();
                            localStorage.removeItem(
                                "billingAddressIdAfterNewAddress"
                            );
                            localStorage.removeItem(
                                "shippingAddressIdAfterNewAddress"
                            );
                            setTimeout(() => {
                                this.$router.push({
                                    name: "thankyou",
                                    params: {
                                        unique_order_id: data.unique_order_id,
                                        last_order_detail_id:
                                            data.last_order_detail_id,
                                        order_id: data.order_id
                                    }
                                });
                            }, 200);
                        } else {
                            console.log(data);
                            localStorage.removeItem(
                                "billingAddressIdAfterNewAddress"
                            );
                            localStorage.removeItem(
                                "shippingAddressIdAfterNewAddress"
                            );
                        }

                        this.$root.$emit("update-cart");
                    })
                    .catch((response) => {
                        console.log(response);
                        _this.isLoader = false;
                        _this.placingOrder = false;
                        if (response.status == 401) {
                            _this.$router.push({ name: "/admin/login" });
                        }
                    });
            });
        },
        placeOrderSplit() {
            var _this = this;

            // Prevent duplicate order placement
            if (_this.isLoader || _this.placingOrder) {
                console.log(
                    "Order placement already in progress, ignoring duplicate call"
                );
                return;
            }

            _this.placingOrder = true;

            // Get split shipment data from Vuex store
            const splitShipmentState = _this.$store.state.splitShipment;
            const splitAddresses = splitShipmentState && splitShipmentState.splitAddresses || [];
            const productAssignments = splitShipmentState && splitShipmentState.productAssignments || {};
            
            if (!splitAddresses || splitAddresses.length === 0) {
                _this.$toast.error("No split addresses found. Please add addresses first.", {
                    position: "top-right"
                });
                _this.placingOrder = false;
                return;
            }

            // Use calculatedGrandTotal for accurate total_price
            _this.order_data.total_price =
                _this.$refs.cartSummaryRef.calculatedGrandTotal;
            _this.order_data.total_setup_fees =
                _this.$refs.cartSummaryRef.total_setup_fee;
            _this.order_data.total_color_fees =
                _this.$refs.cartSummaryRef.total_imprint_locations_price;

            const calculatedGrandTotal =
                _this.$refs.cartSummaryRef.calculatedGrandTotal;
            _this.order_data.grand_total_price =
                calculatedGrandTotal.toFixed(2);
            _this.order_data.order_price = parseFloat(
                calculatedGrandTotal.toFixed(2)
            );
            _this.order_data.total_quantity =
                _this.$refs.cartSummaryRef.total_quantity;

            // Prepare split addresses data
            const splitAddressesData = splitAddresses.map((address, index) => {
                return {
                    split_address_sequence: index + 1,
                    address_id: address.id || address.address_id || null,
                    address_title: address.address_title || null,
                    fullname: address.fullname || null,
                    first_name: address.first_name || null,
                    last_name: address.last_name || null,
                    company_name: address.company_name || null,
                    email: address.email || null,
                    phone: address.phone || null,
                    address_line1: address.address_line1 || null,
                    address_line2: address.address_line2 || null,
                    landmark: address.landmark || null,
                    city: address.city || null,
                    state: address.state || null,
                    country: address.country || 'US',
                    zip: address.zip || null,
                    is_default: address.is_default || 0,
                    shipping_carrier_id: address.shipping_carrier_id || null,
                    shipping_method: address.shipping_method || null,
                    shipping_cost: parseFloat(address.shipping_cost || 0),
                    estimated_delivery_date: address.estimated_delivery_date || null,
                    estimated_delivery_days: address.estimated_delivery_days != null ? parseInt(address.estimated_delivery_days, 10) : null
                };
            });

            // Prepare product assignments data
            // Group assignments by address_sequence
            const assignmentsByAddress = {};
            Object.keys(productAssignments).forEach(key => {
                const assignment = productAssignments[key];
                if (assignment && assignment.address_sequence !== undefined) {
                    const addrSeq = assignment.address_sequence;
                    if (!assignmentsByAddress[addrSeq]) {
                        assignmentsByAddress[addrSeq] = [];
                    }
                    assignmentsByAddress[addrSeq].push({
                        cart_item_id: assignment.cart_item_id || key,
                        child_item_id: assignment.child_item_id || null,
                        quantity: assignment.quantity || 0,
                        address_sequence: addrSeq
                    });
                }
            });

            // Build product_assignments from store (productAssignments) so UI assignments are never lost.
            // productAssignments: { uniqueKey: { addressIndex, addressId, selected, item: { cartItemId, childItemId, quantity, ... } } }
            let cart_items = (_this.$refs.cartSummaryRef && _this.$refs.cartSummaryRef.cart_items) || [];
            _this.syncPatchDetailsForPlaceOrder(cart_items);
            // Ensure every cart item has displayData before building product_assignments (so black/second item gets breakdown too)
            if (cart_items.length > 0 && _this.$refs.cartSummaryRef && _this.$refs.cartSummaryRef.getItemDisplayData) {
                cart_items.forEach((cartItem) => {
                    if (!cartItem.displayData) {
                        const displayData = _this.$refs.cartSummaryRef.getItemDisplayData(cartItem);
                        if (displayData) {
                            cartItem.displayData = displayData;
                        }
                    }
                });
            }
            const product_assignments = [];

            // Aggregate assignments so each (cart_item_id, child_item_id, address_sequence) becomes a single row
            // with split_quantity summed across selected units.
            const grouped = {};

            const tryParseJson = (v) => {
                if (!v) return null;
                try {
                    return typeof v === 'string' ? JSON.parse(v) : v;
                } catch (e) {
                    return null;
                }
            };

            const mergeNameNumberJsonStrings = (jsonStrings) => {
                const merged = {
                    front: [],
                    back: [],
                    left: [],
                    right: [],
                    selected_name_number: {
                        front: { name: false, number: false },
                        back: { name: false, number: false },
                        left: { name: false, number: false },
                        right: { name: false, number: false }
                    }
                };

                let anyMerged = false;

                (jsonStrings || []).forEach((str) => {
                    const obj = tryParseJson(str);
                    if (!obj || typeof obj !== 'object') return;

                    ['front', 'back', 'left', 'right'].forEach((loc) => {
                        if (Array.isArray(obj[loc]) && obj[loc].length > 0) {
                            merged[loc].push(...obj[loc]);
                            anyMerged = true;
                        }
                    });

                    if (obj.selected_name_number) {
                        ['front', 'back', 'left', 'right'].forEach((loc) => {
                            const sel = obj.selected_name_number[loc];
                            if (sel) {
                                merged.selected_name_number[loc].name =
                                    merged.selected_name_number[loc].name || !!sel.name;
                                merged.selected_name_number[loc].number =
                                    merged.selected_name_number[loc].number || !!sel.number;
                            }
                        });
                    }
                });

                if (!anyMerged) return null;

                // Option 2: keep payload clean — only include entries where name/number is filled.
                const isFilled = (row) => {
                    if (!row || typeof row !== 'object') return false;
                    const n = ((row.name != null ? row.name : (row.decorator_name != null ? row.decorator_name : '')) + '').toString().trim();
                    const num = ((row.number != null ? row.number : (row.decorator_number != null ? row.decorator_number : '')) + '').toString().trim();
                    return n.length > 0 || num.length > 0;
                };

                const makeKey = (row) => {
                    if (!row || typeof row !== 'object') return '';
                    if (row.id != null) return `id:${row.id}`;
                    const n = ((row.name != null ? row.name : (row.decorator_name != null ? row.decorator_name : '')) + '').toString().trim();
                    const num = ((row.number != null ? row.number : (row.decorator_number != null ? row.decorator_number : '')) + '').toString().trim();
                    const sz = ((row.size != null ? row.size : '') + '').toString().trim();
                    return `${n}|${num}|${sz}`;
                };

                let anyRemaining = false;
                const cleanedSelected = {
                    front: { name: false, number: false },
                    back: { name: false, number: false },
                    left: { name: false, number: false },
                    right: { name: false, number: false }
                };

                ['front', 'back', 'left', 'right'].forEach((loc) => {
                    const seen = new Set();
                    merged[loc] = (merged[loc] || [])
                        .filter(isFilled)
                        .filter((row) => {
                            const k = makeKey(row);
                            if (!k) return true;
                            if (seen.has(k)) return false;
                            seen.add(k);
                            return true;
                        });

                    if (merged[loc].length > 0) {
                        anyRemaining = true;
                        cleanedSelected[loc].name = merged[loc].some((r) => (((r && r.name != null ? r.name : (r && r.decorator_name != null ? r.decorator_name : '')) + '').toString().trim().length > 0));
                        cleanedSelected[loc].number = merged[loc].some((r) => (((r && r.number != null ? r.number : (r && r.decorator_number != null ? r.decorator_number : '')) + '').toString().trim().length > 0));
                    }
                });

                merged.selected_name_number = cleanedSelected;
                return anyRemaining ? JSON.stringify(merged) : null;
            };

            Object.keys(productAssignments).forEach((key) => {
                const assignment = productAssignments[key];
                if (!assignment) return;
                if (!assignment.selected) return;
                if (!assignment.item) return;

                const assignmentItem = assignment.item;
                const cartItemId = assignmentItem.cartItemId || assignmentItem.cart_item_id || assignmentItem.id;
                const addressSequence = (assignment.addressIndex !== undefined && assignment.addressIndex !== null)
                    ? assignment.addressIndex + 1
                    : (assignment.address_sequence != null ? assignment.address_sequence : null);

                if (addressSequence === null || addressSequence === undefined) return;

                const splitQuantity = parseInt(assignmentItem.quantity || assignment.quantity || 0, 10) || 1;
                if (splitQuantity <= 0) return;

                const childItemId = assignmentItem.childItemId || assignmentItem.child_item_id || null;

                // assignment.name_and_number_json does not exist on the assignment object directly —
                // the per-unit JSON is stored on assignment.item.name_and_number_json (set by SplitItemsByAddress.vue).
                // Use that per-unit value only; do NOT fall back to any other global cart-item JSON.
                const nameAndNumberVal = (assignmentItem.name_and_number_json != null && assignmentItem.name_and_number_json !== '')
                    ? (typeof assignmentItem.name_and_number_json === 'string' ? assignmentItem.name_and_number_json : JSON.stringify(assignmentItem.name_and_number_json))
                    : null;

                const groupKey = `${String(cartItemId)}_${String(childItemId || '')}_${String(addressSequence)}`;
                if (!grouped[groupKey]) {
                    grouped[groupKey] = {
                        cartItemId,
                        childItemId,
                        addressSequence,
                        totalQty: 0,
                        unit_price: assignmentItem.unit_price || 0,
                        nameNumberJsonParts: []
                    };
                }
                grouped[groupKey].totalQty += splitQuantity;
                if (nameAndNumberVal) {
                    grouped[groupKey].nameNumberJsonParts.push(nameAndNumberVal);
                }
            });

            // Build aggregated product_assignments (one row per group)
            Object.keys(grouped).forEach((gk) => {
                const g = grouped[gk];
                const cartItemId = g.cartItemId;
                const childItemId = g.childItemId || null;
                const addressSequence = g.addressSequence;
                const splitQuantity = g.totalQty || 1;

                // Find cart item: top-level or inside subItems (for same-service different-color, cartItemId can be subItem.id)
                let item = cart_items.find((ci) => {
                    const cid = ci.id;
                    return cid == cartItemId || String(cid) === String(cartItemId) || Number(cid) === Number(cartItemId);
                });
                if (!item && cart_items && cart_items.length > 0) {
                    for (const ci of cart_items) {
                        if (ci.subItems && Array.isArray(ci.subItems)) {
                            const sub = ci.subItems.find((s) => s.id == cartItemId || String(s.id) === String(cartItemId));
                            if (sub) {
                                item = sub;
                                break;
                            }
                        }
                    }
                }

                let freshDisplayData = null;
                let setup_fees_details_val = null;
                if (item && _this.$refs.cartSummaryRef && _this.$refs.cartSummaryRef.getItemDisplayData) {
                    const tempItem = JSON.parse(JSON.stringify(item));
                    if (tempItem.CartChildItems && tempItem.CartChildItems.length > 0) {
                        tempItem.CartChildItems.forEach((childItem) => {
                            if (childItemId && (childItem.id == childItemId || String(childItem.id) === String(childItemId))) {
                                childItem.quantity = splitQuantity;
                            } else {
                                childItem.quantity = 0;
                            }
                        });
                    }
                    freshDisplayData = _this.$refs.cartSummaryRef.getItemDisplayData(tempItem);
                    if (!freshDisplayData) {
                        if (item.displayData) {
                            freshDisplayData = item.displayData;
                        } else {
                            const fallbackDisplayData = _this.$refs.cartSummaryRef.getItemDisplayData(item);
                            if (fallbackDisplayData) {
                                item.displayData = fallbackDisplayData;
                                freshDisplayData = fallbackDisplayData;
                            }
                        }
                    }
                    setup_fees_details_val = item.setup_fees_details ? (typeof item.setup_fees_details === 'string' ? item.setup_fees_details : JSON.stringify(item.setup_fees_details)) : null;
                }

                const mergedNameAndNumber = mergeNameNumberJsonStrings(g.nameNumberJsonParts);

                const assignmentData = {
                    cart_item_id: Number(cartItemId) || (item && item.id) || 0,
                    child_item_id: childItemId || null,
                    split_address_sequence: addressSequence,
                    split_quantity: splitQuantity,
                    name_and_number_json: mergedNameAndNumber || null,
                    base_fee: (freshDisplayData && freshDisplayData.baseFeeBreakdown) ? JSON.stringify(freshDisplayData.baseFeeBreakdown) : (item && item.displayData && item.displayData.baseFeeBreakdown ? JSON.stringify(item.displayData.baseFeeBreakdown) : null),
                    run_charge_breakdown: (freshDisplayData && freshDisplayData.runChargeBreakdown) ? JSON.stringify(freshDisplayData.runChargeBreakdown) : (item && item.displayData && item.displayData.runChargeBreakdown ? JSON.stringify(item.displayData.runChargeBreakdown) : null),
                    setup_fees_details: setup_fees_details_val,
                    custom_color_fee: (freshDisplayData && freshDisplayData.customColorBreakdown) ? JSON.stringify(freshDisplayData.customColorBreakdown) : (item && item.displayData && item.displayData.customColorBreakdown ? JSON.stringify(item.displayData.customColorBreakdown) : null),
                    rush_fee_breakdown: (freshDisplayData && freshDisplayData.rushFeeBreakdown)
                        ? (typeof freshDisplayData.rushFeeBreakdown === 'string' ? freshDisplayData.rushFeeBreakdown : JSON.stringify(freshDisplayData.rushFeeBreakdown))
                        : (item && item.displayData && item.displayData.rushFeeBreakdown
                            ? (typeof item.displayData.rushFeeBreakdown === 'string' ? item.displayData.rushFeeBreakdown : JSON.stringify(item.displayData.rushFeeBreakdown))
                            : null),
                    design_fee: 0,
                    name_numbers_fees: 0,
                    non_standard_fees: 0,
                    item_sub_total: (freshDisplayData && freshDisplayData.itemSubTotal)
                        ? freshDisplayData.itemSubTotal
                        : (item && item.displayData && item.displayData.itemSubTotal
                            ? item.displayData.itemSubTotal
                            : (g.unit_price ? g.unit_price * splitQuantity : 0))
                };
                product_assignments.push(assignmentData);
            });

            // Prepare order data for split shipment
            _this.order_data.split_addresses = splitAddressesData;
            _this.order_data.product_assignments = product_assignments;
            _this.order_data.split_shipment_count = splitAddresses.length;

            // Include cart_items - backend needs this to create order items
            // cart_items is already declared above, just ensure displayData is fresh and add to order_data
            if (cart_items && cart_items.length > 0) {
                // Ensure displayData breakdowns and estimated_shipping_date are available in cart_items before sending
                cart_items.forEach((item) => {
                    // Recalculate displayData to ensure breakdowns are fresh
                    const freshDisplayData =
                        _this.$refs.cartSummaryRef.getItemDisplayData(item);
                    if (freshDisplayData) {
                        item.displayData = freshDisplayData;
                    }
                    // Add estimated_shipping_date from frontend (same as standard place order) so backend can save it
                    if (_this.$refs.cartSummaryRef.getEstimatedShippingDate) {
                        const estimatedDateStr =
                            _this.$refs.cartSummaryRef.getEstimatedShippingDate(item);
                        if (estimatedDateStr) {
                            const [month, day, year] = estimatedDateStr.split("/");
                            const formattedDate = `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
                            item.estimated_shipping_date = formattedDate;
                            // Set same date on all subItems (e.g. second color) so backend gets correct value per item
                            if (item.subItems && Array.isArray(item.subItems)) {
                                item.subItems.forEach((sub) => {
                                    sub.estimated_shipping_date = formattedDate;
                                });
                            }
                        }
                    }
                });
            }
            _this.order_data.cart_items = cart_items || [];

            // Get shipping breakdown data from CartSummary
            _this.order_data.shipping_cost_breakdown =
                _this.$refs.cartSummaryRef.getShippingBreakdown();

            // Get packaging breakdown data from CartSummary
            _this.order_data.packaging_kitting_handling_breakdown =
                _this.$refs.cartSummaryRef.getPackagingBreakdown();

            // Get sales tax breakdown data from CartSummary
            _this.order_data.sales_tax_breakdown =
                _this.$refs.cartSummaryRef.getSalesTaxBreakdown();

            // Use getSalesTaxTotal() to include sales tax
            _this.order_data.sales_tax =
                _this.$refs.cartSummaryRef.getSalesTaxTotal();

            // Set billing address data
            if (localStorage.getItem("billingAddressIdAfterNewAddress")) {
                _this.order_data.billingaddressid = localStorage.getItem(
                    "billingAddressIdAfterNewAddress"
                );
            }
            if (localStorage.getItem("shippingAddressIdAfterNewAddress")) {
                _this.order_data.shippingaddressid = localStorage.getItem(
                    "shippingAddressIdAfterNewAddress"
                );
            }
            _this.isLoader = true;

            _this.order_data.balance_after_order =
                parseFloat(_this.term_payment_info.avalaible_on_account) -
                parseFloat(_this.order_data.grand_total_price);
            _this.order_data.term_payment_info = _this.term_payment_info;
            _this.order_data.admin_user_id =
                localStorage.getItem("admin_user_id");

            // `remarks` on server = specialcomment + comment (billing). Split billing text lives in `billing_order_comment`.
            const billingNote =
                _this.order_data.billing_order_comment != null &&
                String(_this.order_data.billing_order_comment).trim()
                    ? String(_this.order_data.billing_order_comment).trim()
                    : _this.order_data.comment != null &&
                        String(_this.order_data.comment).trim()
                      ? String(_this.order_data.comment).trim()
                      : "";
            _this.order_data.comment = billingNote;

            new Promise(() => {
                ApiService.post("/placeordersplit", _this.order_data)
                    .then(({ data }) => {
                        _this.isLoader = false;
                        _this.placingOrder = false;
                        const closeBtn = document.getElementById("popup-close-address");
                        if (closeBtn) {
                            closeBtn.click();
                        }
                        if (data.success) {
                            _this.$toast.success(data.message, {
                                position: "top-right"
                            });
                            _this.emptyCart();
                            localStorage.removeItem(
                                "billingAddressIdAfterNewAddress"
                            );
                            localStorage.removeItem(
                                "shippingAddressIdAfterNewAddress"
                            );
                            localStorage.removeItem("billingAddressIdSplit");
                            // Reset split shipment state
                            _this.$store.commit('splitShipment/resetSplitShipment');
                            setTimeout(() => {
                                this.$router.push({
                                    name: "thankyou",
                                    params: {
                                        unique_order_id: data.unique_order_id,
                                        last_order_detail_id:
                                            data.last_order_detail_id,
                                        order_id: data.order_id
                                    }
                                });
                            }, 200);
                        } else {
                            console.log(data);
                            localStorage.removeItem(
                                "billingAddressIdAfterNewAddress"
                            );
                            localStorage.removeItem(
                                "shippingAddressIdAfterNewAddress"
                            );
                            localStorage.removeItem("billingAddressIdSplit");
                        }

                        this.$root.$emit("update-cart");
                    })
                    .catch((response) => {
                        console.log(response);
                        _this.isLoader = false;
                        _this.placingOrder = false;
                        if (response.status == 401) {
                            _this.$router.push({ name: "/admin/login" });
                        }
                    });
            });
        },
        emptyCart() {
            var _this = this;
            localStorage.removeItem("cart");
            localStorage.setItem("cartNotEmpty", false);
            _this.cart_items = [];

            if (_this.currentUserClient.id) {
                _this.isBusy = true;
                ApiService.post("/empty-cart")
                    .then(() => {
                        _this.isBusy = false;
                    })
                    .catch((response) => {
                        console.log(response);
                        _this.isBusy = false;
                    });
                return;
            }

            _this.$root.$emit("update-cart");
        },
        getUser() {
            var _this = this;
            new Promise(() => {
                ApiService.get("/user-profile")
                    .then(({ data }) => {
                        let user = data.user;
                        // console.log(
                        //     user,
                        //     user["email_activation"],
                        //     "checkout here aaaaaaaa"
                        // );

                        if (!user["email_activation"]) {
                            _this.email_verified = true;
                            _this.getting_email = user["email"];
                        }

                        if (this.currentUserClient.netsuite_id) {
                            this.getCustomerDetailsFromNetsuite(
                                this.currentUserClient.netsuite_id
                            );
                            this.getCustomerTermDetails(
                                this.currentUserClient.netsuite_id
                            );
                        }
                    })
                    .catch(({ response }) => {
                        console.log(response);
                        if (response.status == 401) {
                            _this.$router.push({ name: "/admin/login" });
                        }
                    });
            });
        },
        getCustomerDetailsFromNetsuite(external_id) {
            return new Promise((resolve, reject) => {
                let params = { external_id };
                ApiService.query("get-customer-from-netsuite", { params })
                    .then(async ({ data }) => {
                        this.netsuite_customer_data = data.customer;
                        resolve(data);
                    })
                    .catch((response) => {
                        console.log(response);
                        this.$toast.error(
                            "getCustomerDetailsFromNetsuite: Something went wrong",
                            { position: "top-right" }
                        );
                        reject(response);
                    });
            });
        },
        getCustomerTermDetails(external_id) {
            return new Promise((resolve, reject) => {
                ApiService.query("/get-customer-term-details", {
                    params: { external_id }
                })
                    .then(async ({ data }) => {
                        if (!data.success) {
                            this.$toast.error(
                                "Something went wrong in term payment, Please contact administrator.",
                                { position: "top-right", queue: true }
                            );
                            return;
                        }

                        let termDetails = data.termDetails;
                        if (termDetails.length > 0) {
                            await this.getUnsyncedOrdersAmount();

                            let term_payment_details = termDetails[0];

                            this.term_payment_info.creditlimit = parseFloat(
                                term_payment_details.creditlimit || 0
                            );
                            this.term_payment_info.overdue_balance = parseFloat(
                                term_payment_details.overdue_balance || 0
                            );
                            this.term_payment_info.unbilled_orders =
                                parseFloat(
                                    term_payment_details.unbilled_orders || 0
                                ) + parseFloat(this.unsynced_orders_amount);
                            this.term_payment_info.unpaid_invoices = parseFloat(
                                term_payment_details.unpaid_invoices || 0
                            );
                            this.term_payment_info.avalaible_on_account =
                                parseFloat(
                                    term_payment_details.avalaible_on_account ||
                                        0
                                ) - parseFloat(this.unsynced_orders_amount);
                            this.term_payment_info.unapplied_credits =
                                parseFloat(
                                    term_payment_details.unapplied_credits || 0
                                );
                        }

                        resolve(data);
                    })
                    .catch((err) => {
                        console.log(err);
                        reject(err);
                    });
            });
        },
        updateCustomerInNetsuite(sameaddress, address_data) {
            return new Promise((resolve, reject) => {
                let params = {
                    id: this.currentUserClient.id,
                    first_name: this.currentUserClient.first_name,
                    last_name: this.currentUserClient.last_name,
                    email: this.currentUserClient.email,
                    alt_phone_no: address_data.phone_no,
                    mobile: this.currentUserClient.mobile,
                    external_id: this.currentUserClient.netsuite_id,
                    same_address: sameaddress,
                    address_data: address_data
                };

                if (address_data && address_data["billing_address"]) {
                    params["alt_phone_no"] =
                        address_data["billing_address"]["phone"];
                    params["email"] = address_data["billing_address"]["email"];
                } else if (address_data && address_data["shipping_address"]) {
                    params["alt_phone_no"] =
                        address_data["shipping_address"]["phone"];
                    params["email"] = address_data["shipping_address"]["email"];
                }

                ApiService.post("update-customer-in-netsuite", params)
                    .then((response) => {
                        setTimeout(() => {
                            this.getCustomerDetailsFromNetsuite(
                                response.data.external_id
                            ).then((data) => {
                                resolve(data.customer);
                            });
                        }, 1000);
                    })
                    .catch((response) => {
                        this.$toast.error(
                            "updateCustomerInNetsuite: Something went wrong",
                            { position: "top-right" }
                        );
                        reject(response);
                    });
            });
        },
        getOrdersCount() {
            return new Promise((resolve, reject) => {
                ApiService.get("/orders-count")
                    .then(({ data }) => {
                        if (!data.success) {
                            this.$toast.error(data.error, {
                                position: "top-right",
                                queue: true
                            });
                            return;
                        }

                        this.total_orders = data.total_orders;
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getUnsyncedOrdersAmount() {
            return new Promise((resolve, reject) => {
                ApiService.get("/unsynced-orders-amount")
                    .then(({ data }) => {
                        if (!data.success) {
                            this.$toast.error(data.error, {
                                position: "top-right",
                                queue: true
                            });
                            return;
                        }

                        this.unsynced_orders_amount = data.total_amount;
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        goBackToCart() {
            if (this.$store && this.$store.state && this.$store.state.splitShipment) {
                this.$store.commit('splitShipment/resetSplitShipment');
            }
            this.split_shipment_step = null;
            this.$router.push({ path: "/cart/v3" });
        },
        proceedToSplitItems() {
            const addresses = this.$store.state.splitShipment && this.$store.state.splitShipment.splitAddresses;
            
            if (!addresses || addresses.length === 0) {
                console.error("[Checkout] No addresses found in Vuex, cannot proceed");
                this.$toast.error("No addresses found. Please add addresses first.", {
                    position: "top-right"
                });
                return;
            }
            
            // Move to next step: Split Items by Address
            this.split_shipment_step = 'split_items';
        },
        goBackToAddresses() {
            // Go back to addresses step
            this.split_shipment_step = 'addresses';
        },
        proceedToPackaging() {
            // Packaging step skipped: default is standard (Vuex packagingOptions.boxType already 'standard')
            this.split_shipment_step = 'charges';
        }
    }
};
</script>
<style scoped>
.shipping_payment_detail{
    margin-bottom: 50px;
}
</style>
